var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import createMaxWidths from './createMaxWidths';
import * as CustomColors from './colors';
export function createMyTheme(options) {
    return createMuiTheme(__assign(__assign({ maxWidths: createMaxWidths() }, options), { palette: __assign({ primary: CustomColors.primary, secondary: CustomColors.secondary, error: CustomColors.negative, grey: CustomColors.grey, ok: CustomColors.positive, warning: CustomColors.warning, orange: CustomColors.orange, white: CustomColors.white }, options.palette), typography: __assign({ fontFamily: "'Source Sans Pro', 'Helvetica', 'Arial', 'sans-serif'", fontSize: 14 }, options.typography), customSpacing: {
            formRow: 1.4,
            navHeight: 56,
            navHeightLg: 64,
        }, overrides: {
            MuiCssBaseline: {
                '@global': {
                    body: {
                        fontSize: '1rem',
                        lineHeight: '1.5',
                        color: CustomColors.grey[700],
                        backgroundColor: CustomColors.white.main,
                    },
                    img: {
                        verticalAlign: 'middle',
                    },
                    a: {
                        color: CustomColors.grey[700],
                    },
                },
            },
        } }));
}
var theme = createMyTheme({});
export default theme;
//# sourceMappingURL=index.js.map